export const SYMBOL_INDEX_VERSION = 11;
